import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  createReportRun as apiCreateReportRun,
  deleteReportRun as apiDeleteReportRun,
  updateReportRun as apiUpdateReportRun,
} from '../api/build-a-dash-api';
import type { ReportRun } from '../components/Reports/types';
import { reportRunQueryKeys } from './useReportRunQuery';

export function useReportRunMutations() {
  const queryClient = useQueryClient();

  const createReportRun = useMutation({
    mutationFn: (run: Omit<ReportRun, 'id'>) =>
      apiCreateReportRun(run as ReportRun),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: reportRunQueryKeys.lists() });
    },
  });

  const updateReportRun = useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<ReportRun> }) =>
      apiUpdateReportRun(id, data),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: reportRunQueryKeys.detail(variables.id),
      });
      queryClient.invalidateQueries({ queryKey: reportRunQueryKeys.lists() });
    },
  });

  const deleteReportRun = useMutation({
    mutationFn: (id: string) => apiDeleteReportRun(id),
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({
        queryKey: reportRunQueryKeys.detail(id),
      });
      queryClient.invalidateQueries({ queryKey: reportRunQueryKeys.lists() });
    },
  });

  return {
    handleCreateReportRun: createReportRun,
    handleUpdateReportRun: updateReportRun,
    handleDeleteReportRun: deleteReportRun,
  };
}
